import React, { type FC } from "react"
import Spacing from "@components/Spacing"

const StrapiSpacer: FC<Queries.StrapiComponentSectionsSpacer> = ({
    size
}) => {
    return <Spacing size={size} />
}

export default StrapiSpacer
